<template>
  <div id="flash-swf">
     <object v-show="!flash_support">
            <object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%" id="Scene">
                <param name="movie" value="Scene.swf" />
                <param name="quality" value="high" />
                <param name="bgcolor" value="#ffffff" />
                <param name="allowScriptAccess" value="sameDomain" />
                <param name="allowFullScreen" value="true" />
                <!--[if !IE]>-->
                <object type="application/x-shockwave-flash" data="Scene.swf" width="100%" height="100%">
                    <param name="quality" value="high" />
                    <param name="bgcolor" value="#ffffff" />
                    <param name="allowScriptAccess" value="sameDomain" />
                    <param name="allowFullScreen" value="true" />
                <!--<![endif]-->
                <!--[if gte IE 6]>-->
                    <p>
                       亲~您的电脑没有安装flash最新版,或者浏览器禁用了flash
                    </p>
                <!--<![endif]-->
                    <a href="http://www.adobe.com/go/getflashplayer">
                        <img src="http://www.adobe.com/images/shared/download_buttons/get_flash_player.gif" alt="Get Adobe Flash Player" />
                    </a>
                <!--[if !IE]>-->
                </object>
                <!--<![endif]-->
            </object>
        </object>
  </div>

</template>

<script>
import EUY from "@/common/scripts/euy";
export default {
    data(){
        return {
            'flash_support':false
        }
    },
    props: ["attributes", "flashvars"],
    methods: {
        checkFlash() {
            var hasFlash = 0; //是否安装了flash
            var flashVersion = 0; //flash版本
            if (document.all) {
                var swf = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
                if (swf) {
                    hasFlash = 1;
                    VSwf = swf.GetVariable("$version");
                    flashVersion = parseInt(VSwf.split(" ")[1].split(",")[0]);
                }
            } else {
                if (navigator.plugins && navigator.plugins.length > 0) {
                    var swf = navigator.plugins["Shockwave Flash"];
                    if (swf) {
                        hasFlash = 1;
                        var words = swf.description.split(" ");
                        for (var i = 0; i < words.length; ++i) {
                            if (isNaN(parseInt(words[i]))) continue;
                            flashVersion = parseInt(words[i]);
                        }
                    }
                }
            }
            if(0 < hasFlash)
            {
                this.flash_support = true
            }
            if(25 > flashVersion)
            {
                this.flash_support = false
            }
            return  this.flash_support
        },
        createFlash() {
            if (this.attributes.id == "PLAYER-SWF") {
                let URL = ""
                let width = ""
                let height = ""
                let swfVersionStr = "25.0.0"
                let params = {}
                params.wmode = "direct"
                params.allowscriptaccess = "always"
                URL = process.env.MOVIE_PLAYER_SWF
                width = "100%"
                if(this.attributes.height) {
                    height = this.attributes.height;
                }
                this.flashvars.msgtype = this.$route.query.platform

                swfobject.embedSWF(
                    URL,
                    "flash-swf",
                    width,
                    height,
                    swfVersionStr,
                    "",
                    this.flashvars,
                    params,
                    this.attributes
                );
            } else {
                let flashvars = {}
                flashvars.msgtype = this.$route.query.platform
                flashvars.assetsUrl = this.flashvars.assetsUrl
                flashvars.host = "localhost"
                flashvars.port = 9270
                let swfVersionStr = "25.0.0"
                let params = {}
                params.wmode = "direct"
                params.allowscriptaccess = "always"

                let URL = ""
                let width = ""
                let height = ""

                if (this.attributes.id == "SCENE-SWF") {
                    URL = EUY.GetStorage("editor_url").editor_animation_url
                    width = "100%"
                    height = "100%"
                }

                if (this.attributes.id == "TIMELINE-SWF") {
                    URL = EUY.GetStorage("editor_url").timeline_url
                    width = "100%"
                    height = "78px"
                }

                if (this.attributes.id == "ACTIONTIMELINE-SWF") {
                    URL = EUY.GetStorage("editor_url").action_timeline_url
                    width = "100%"
                    height = "96px"
                }
                swfobject.removeSWF(this.attributes.id)
                swfobject.embedSWF(
                    URL,
                    "flash-swf",
                    width,
                    height,
                    swfVersionStr,
                    "",
                    flashvars,
                    params,
                    this.attributes
                );
            }
        }
    },
    mounted() {
        if (this.attributes.id == "SCENE-SWF") {
            this.checkFlash()
        }
        this.createFlash();
    }
};
</script>

<style lang="stylus">
object {
  display: block;
  text-align:center;
}
  p {
    margin-bottom:32px
  }
#flash-swf{
  position:absolute
  width: 100%
}


.psocket {
  position: absolute;
  left: -9999px;
}
</style>



// WEBPACK FOOTER //
// FlashSwf.vue?75770abe